// extracted by mini-css-extract-plugin
export var columns = "BehavioralDataCallout-module--columns--0c21e";
export var connectors = "BehavioralDataCallout-module--connectors--c6dee";
export var image = "BehavioralDataCallout-module--image--2861d";
export var item = "BehavioralDataCallout-module--item--1a0d9";
export var label = "BehavioralDataCallout-module--label--77f9c";
export var mobileVisual = "BehavioralDataCallout-module--mobile-visual--554fb";
export var rows = "BehavioralDataCallout-module--rows--ed6ac";
export var section = "BehavioralDataCallout-module--section--87fc0";